import { FieldValidationResult } from '@payaca/types/fieldValidationTypes';
import { clsx } from '@payaca/utilities/cvaMerge';
import React, { FunctionComponent, useMemo, type JSX } from 'react';
import { ErrorMessage } from '../feedbackMessage/FeedbackMessage';
import './ValidatedFieldWrapper.sass';

type Props = {
  children: JSX.Element | (JSX.Element | undefined)[];
  validationResult?: FieldValidationResult;
  isTouched?: boolean;
  className?: string;
};

const ValidatedFieldWrapper: FunctionComponent<
  React.PropsWithChildren<Props>
> = ({
  children,
  validationResult,
  isTouched = true,
  className,
}: React.PropsWithChildren<Props>): JSX.Element => {
  const isInvalid = useMemo(() => {
    if (!validationResult) return false;
    if (!isTouched) return false;
    return !validationResult.isValid;
  }, [validationResult, isTouched]);

  const validationErrors = useMemo(() => {
    return validationResult?.errors || [];
  }, [validationResult]);

  return (
    <div
      className={clsx(
        `validated-field-wrapper${isInvalid ? ' invalid' : ''}`,
        className
      )}
    >
      {children}
      {validationErrors && !!validationErrors.length && (
        <div className="validation-errors">
          {validationErrors.map((error, index) => {
            return <ErrorMessage message={error} key={index} />;
          })}
        </div>
      )}
    </div>
  );
};

export default ValidatedFieldWrapper;
